import { __assign, __spreadArray } from '../../../../../../node_modules/tslib/tslib.es6.js';

var filterFns = {
    inNumberRange: function (value, filterValue) {
        if (!Array.isArray(filterValue))
            return false;
        var min = filterValue[0], max = filterValue[1];
        return ((!min && min !== 0) || value >= min) && ((!max && max !== 0) || value <= max);
    },
    includesString: function (value, filterValue) {
        return value.toLowerCase().includes(filterValue.toLowerCase());
    },
};
var checkFilterValue = function (filter, value) {
    if (!value)
        return value;
    if (filter.type === "slider" && Array.isArray(value)) {
        var newValue = __spreadArray([], value, true);
        if (filter.min !== undefined && value[0] < filter.min) {
            newValue[0] = null;
        }
        if (filter.max !== undefined && value[1] > filter.max) {
            newValue[1] = null;
        }
        return newValue;
    }
    else if (filter.type === "select") {
        if (!filter.options.find(function (option) { return option.value === value; })) {
            return filter.value;
        }
    }
    else if (filter.type === "checkbox") {
        if (!value.every(function (val) {
            return filter.options.find(function (option) { return option.value === val; });
        })) {
            return filter.value;
        }
    }
    return value;
};
var loadFilters = function (defaultFilters, savedFilterValues) {
    if (savedFilterValues === void 0) { savedFilterValues = []; }
    return defaultFilters.map(function (filter) {
        var savedFilter = savedFilterValues.find(function (savedFilter) { return savedFilter.id === filter.id && savedFilter.type === filter.type; });
        var value = filter.value;
        if (savedFilter) {
            value = checkFilterValue(filter, savedFilter.value);
        }
        return __assign(__assign({}, filter), { value: value });
    });
};
var pruneFilters = function (filters) {
    return filters.map(function (_a) {
        var id = _a.id, value = _a.value, type = _a.type;
        return ({
            id: id,
            value: value,
            type: type,
        });
    });
};
var filterData = function (filter, value) {
    if (!filter || filter.value === "" || filter.value === null || filter.value === undefined)
        return true;
    if (filter.type === "slider")
        return filterFns.inNumberRange(value, filter.value);
    else if (filter.type === "checkbox")
        return filter.value.includes(value);
    else if (filter.type === "select")
        return filter.value === value;
    else if (filter.type === "text") {
        return filterFns.includesString(value, filter.value);
    }
    return true;
};

export { filterData, filterFns, loadFilters, pruneFilters };
